<template>
    <span class="md-badge" :class="{ 'md-badge--current': value === 'MD' }">{{ value }}</span>
</template>

<script>
export default {
    name: 'MatchDayBadge',
    props: {
        value: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>
.md-badge {
    height: 18px;
    padding: 0 6px;
    border-radius: 9px;
    display: inline-flex;
    align-items: center;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: .02em;
    white-space: nowrap;
    flex-shrink: 0;
    background: rgba(153, 102, 204, .16);
    color: #9966CC;
}

.md-badge--current {
    background: #9966CC;
    color: #fff;
}

.theme--light .md-badge {
    color: #7C4DBC;
}

.theme--light .md-badge--current {
    background: #7C4DBC;
    color: #fff;
}
</style>
